import GuidelinesContent from "components/GuidelinesContent";

export default function Guidelines() {
  return <GuidelinesContent />;
}
